import React from "react";
import { useState } from "react";
import { Country, State } from "country-state-city";
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";
import { updateContactSuppport } from "./service";
import { useSelector } from "react-redux";

const ContactSupport = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);

  const [values, setValues] = useState({});
  const [states, setstates] = useState();
  const [country, setCountry] = useState();
  const [disableblock, setDisableblock] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    let country = Country.getAllCountries();
    setCountry(country);
  }, []);

  const formValidation = () => {
    const { country, email, issues, name, state, message, platform, topic } =
      values;
    let validationStatus = true;
    let error = {};
    let emailRegex = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (!country || country === "Select Country") {
      error.country = "Required!";
      validationStatus = false;
    }

    if (!email) {
      error.email = "Required!";
      validationStatus = false;
    } else if (!email?.match(emailRegex)) {
      error.email = "Enter a valid email!";
      validationStatus = false;
    }

    if (!issues) {
      error.issues = "Required!";
      validationStatus = false;
    } else if (issues === "Technical Issue") {
      if (!platform || platform === "Select Platform") {
        error.platform = "Required!";
        validationStatus = false;
      }
      if (!topic || topic === "Select Topic") {
        error.topic = "Required!";
        validationStatus = false;
      }
    }

    if (!name) {
      error.name = "Required!";
      validationStatus = false;
    }

    if (!state || state === "Select State") {
      error.state = "Required!";
      validationStatus = false;
    }

    if (!message) {
      error.message = "Required!";
      validationStatus = false;
    } else if (message?.length < 5) {
      error.message = "Minimum 5 Character Required!";
      validationStatus = false;
    }
    setErrors(error)
    return validationStatus;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      let state = State.getStatesOfCountry(value);
      setstates(state);
      setValues({
        ...values,
        [name]: value,
      });
    } else if (name === "issues") {
      setValues({
        ...values,
        [name]: value,
      });
      if (value === "Technical Issue") {
        setDisableblock(true);
      } else {
        setDisableblock(false);
      }
    } else {

      setValues({
        ...values,
        [name]: value,
      });
    }
  };

  const submitHandler = (e) => {
    e.preventDefault()
    if (submitting) return;
    if (formValidation()) {
      let country = Country.getAllCountries();
      const countryArray = country.filter(
        (countryItem) => countryItem.isoCode == values?.country
      );
      values.country = countryArray[0]?.name;
      updateContact();
    }
  }

  const updateContact = async () => {
    setSubmitting(true);
    try {
      const response = await updateContactSuppport(appInfo, values);
      if (response?.status === 200) {
        toast.success("Thanks. We will get back to you shortly", {
          position: "bottom-center",
        });
        setValues({});
        setstates(undefined);
        setDisableblock(false);
        setErrors({});
        setFormKey((prev) => prev + 1);
      }
    } catch (err) {
      toast.error(err?.message, {
        position: "bottom-center",
      });
    } finally {
      setSubmitting(false);
    }

  }

  return (
    <div className="contactSupport">
      <div className="wrapper">
        <h1 className="heading">Support</h1>
        <div className="formContainer">
          <form key={formKey}>
            <div className="full">
              <input
                type="text"
                name="name"
                placeholder="Name"
                onChange={handleChange}
              />
              {
                errors?.name &&
                <span className="error">{errors?.name}</span>
              }
            </div>
            <div className="full">
              <input
                type="email"
                name="email"
                placeholder="Email"
                onChange={handleChange}
              />
              {
                errors?.email &&
                <span className="error">{errors?.email}</span>
              }
            </div>
            <div className="full">
              <select name="country" id="country" onChange={handleChange}>
                <option>Select Country</option>
                {country?.map((item, index) => {
                  return (
                    <option key={index} value={item.isoCode}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
              {
                errors?.country &&
                <span className="error">{errors?.country}</span>
              }
            </div>
            <div className="full">
              <select name="state" id="state" onChange={handleChange}>
                <option>Select State</option>
                {states?.map((item, index) => {
                  return (
                    <option key={index} value={item.name}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
              {
                errors?.state &&
                <span className="error">{errors?.state}</span>
              }
            </div>
            <div className="full">
              <input
                type="text"
                name="movie"
                placeholder="Movie/show title (optional)"
                onChange={handleChange}
              />
              {
                errors?.movie &&
                <span className="error">{errors?.movie}</span>
              }
            </div>
            <div className="full">
              <select name="issues" id="issues" onChange={handleChange}>
                <option>Select One</option>
                <option value="Technical Issue">Technical Issue</option>
                <option value="Advertise of us">Advertise of us</option>
                <option value="Partner with us">Partner with us</option>
                <option value="Other">Other</option>
              </select>
              {
                errors?.issues &&
                <span className="error">{errors?.issues}</span>
              }
            </div>
            {disableblock === true && (
              <>
                <div className="full">
                  <select name="platform" id="platform" onChange={handleChange}>
                    <option>Select Platform</option>
                    <option value="Website">Website</option>
                    <option value="Roku">Roku</option>
                    <option value="Android">Android</option>
                    <option value="iOS">iOS</option>
                    <option value="Apple TV">Apple TV</option>
                    <option value="Android TV">Android TV</option>
                    <option value="Amazon Fire">Amazon Fire</option>
                  </select>
                  {
                    errors?.platform &&
                    <span className="error">{errors?.platform}</span>
                  }
                </div>
                <div className="full">
                  <select name="topic" id="topic" onChange={handleChange}>
                    <option value="Select Topic">Select Topic</option>
                    <option value="Account">Account</option>
                    <option value="Audio">Audio</option>
                    <option value="Content">Content</option>
                    <option value="Content Request">Content Request</option>
                    <option value="Registration">Registration</option>
                    <option value="Sign-In">Sign-In</option>
                    <option value="Subtitle">Subtitle - Caption</option>
                    <option value="Video Playlist">Video Playlist</option>
                    <option value="Other">Other</option>
                  </select>
                  {
                    errors?.topic &&
                    <span className="error">{errors?.topic}</span>
                  }
                </div>
              </>
            )}

            <div className="full message">
              <label htmlFor="message">Message</label>
              <textarea name="message" onChange={handleChange}></textarea>
              {
                errors?.message &&
                <span className="error">{errors?.message}</span>
              }
            </div>
            <div className="full">
              <div className="buttonContainer" onClick={(e) => submitHandler(e)}>
                <div className="background" />
                <button disabled={submitting}>{submitting ? "Submitting..." : "Submit"}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;
